import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import generateSaleReturnPDF from './Bill';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

const SaleReturnDetails = () => {
    const { id } = useParams();
    const [formData, setFormData]             = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [selectedSalesMan, setSelectedSalesMan]   = useState('');
    const [selectedCardType, setSelectedCardType]   = useState('');
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const { isAuthenticated, companyId, branchId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, token, logout]);

    useEffect(() => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then(r => setDropdownSalesManOptions(r.response_data || []))
            .catch(console.error);
        fetchData('SaleReturnApi', `/CardType/${companyId}/${branchId}`, token)
            .then(r => setDropdownCardTypeOptions(r.response_data || []))
            .catch(console.error);
    }, []);

    useEffect(() => {
        fetchData('SaleReturnApi', `/${id}`, token)
            .then(response => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                }
            })
            .catch(console.error);
    }, [id]);

    const handlePrint = async () => {
        try {
            const response = await fetchData('SaleReturnApi', `/SalePrint/${id}/${branchId}`, token);
            generateSaleReturnPDF(response.response_data);
        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    const fmt2 = (v) => (parseFloat(v) || 0).toFixed(2);

    return (
        <Fragment>
            <div className="pg-container">
                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Sale Return — Details</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-outline" onClick={handlePrint}>
                                <PrintIcon /> Print
                            </button>
                            <Link to="/SaleReturnIndex" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Back to List
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="pg-card">
                    {/* ── Row 1: Customer Name / Bill Date / Bill No / Total Qty / Addt'l Disc % ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Customer Name</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.CustomerName || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.BillDate)} disabled />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill No</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 80px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Addt'l Disc %</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.AdditionalDiscountPercentage || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Row 2: Address / GST Number / Phone No / Sales Man / Sale Bill No / Sale Bill Date ── */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Address</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.CustomerAddress || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                            <span className="pg-hcell-label">GST Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.GSTNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Phone No</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.ContactNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sales Man</span>
                            <select className="pg-hcell-select" value={selectedSalesMan} disabled>
                                <option value="">Select Sales Man</option>
                                {dropdownSalesManOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sale Bill No</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.SaleBillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Sale Bill Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.SaleBillDate)} disabled />
                        </div>
                    </div>

                    {/* ── Items table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Item Name</th>
                                    <th className="right">Qty</th>
                                    <th className="right">MRP</th>
                                    <th className="right">Disc %</th>
                                    <th className="right">Addt'l Disc %</th>
                                    <th className="right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={7} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items found.</td></tr>
                                    : invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{index + 1}</td>
                                            <td style={{ width: '35%' }}>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right">{item.DiscountPercentage}</td>
                                            <td className="right">{item.AdditionalDiscountPercentage}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* ── Totals Panel ── */}
                    <div className="pg-totals-panel">
                        {/* Left: summary figures */}
                        <div className="pg-totals-left">
                            <div className="pg-totals-summary">
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Amount</span>
                                    <span className="pg-tsum-value">{fmt2(formData.TotalAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Discount</span>
                                    <span className="pg-tsum-value">{fmt2(formData.DiscountAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Cash Disc</span>
                                    <span className="pg-tsum-value">{fmt2(formData.CashDiscount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">GV Amount</span>
                                    <span className="pg-tsum-value">{fmt2(formData.GVAmount)}</span>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Net Amount</span>
                                    <span className="pg-tsum-value">{fmt2(formData.TaxableAmount)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="pg-totals-divider" />

                        {/* Right: GST + Grand Total + Payments */}
                        <div className="pg-totals-right">
                            {/* GST row */}
                            <div className="pg-totals-gst-row">
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">CGST</span>
                                    <span className="pg-tgst-value">{fmt2(formData.CGSTAmount)}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">SGST</span>
                                    <span className="pg-tgst-value">{fmt2(formData.SGSTAmount)}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">IGST</span>
                                    <span className="pg-tgst-value">{fmt2(formData.IGSTAmount)}</span>
                                </div>
                                <div className="pg-tgst-cell">
                                    <span className="pg-tgst-label">Round Off</span>
                                    <span className="pg-tgst-value">{formData.RoundOff}</span>
                                </div>
                            </div>

                            {/* Grand Total bar */}
                            <div className="pg-grand-total-bar">
                                <span className="pg-gt-label">Grand Total</span>
                                <span className="pg-gt-value">{fmt2(formData.GrandTotal)}</span>
                            </div>

                            {/* Payment row */}
                            <div className="pg-totals-pay-row">
                                <div className="pg-tpay-cell">
                                    <label className="pg-tpay-label">Cash</label>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt2(formData.CashAmount)} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <label className="pg-tpay-label">Card</label>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt2(formData.CardAmount)} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <label className="pg-tpay-label">UPI / RTGS / Other</label>
                                    <input className="pg-tpay-input" type="text"
                                        value={fmt2(formData.UPIAmount)} readOnly />
                                </div>
                            </div>

                            {/* Conditional extra fields */}
                            {(formData.CardAmount > 0 || formData.UPIAmount > 0) && (
                                <div className="pg-tpay-extra-row">
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <label className="pg-tpay-label">Card Type</label>
                                            <select className="pg-tpay-select" value={selectedCardType} disabled>
                                                <option value="">Select Card Type</option>
                                                {dropdownCardTypeOptions.map(c => <option key={c.Id} value={c.Id}>{c.Name}</option>)}
                                            </select>
                                        </div>
                                    )}
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <label className="pg-tpay-label">Card Number</label>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.CardNumber || ''} readOnly />
                                        </div>
                                    )}
                                    {formData.UPIAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <label className="pg-tpay-label">UPI / RTGS / Other No.</label>
                                            <input className="pg-tpay-input" type="text"
                                                value={formData.UPINumber || ''} readOnly />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default SaleReturnDetails;
